"use client"

import type { ReactNode, Ref, TextareaHTMLAttributes } from "react"

import { useFieldA11y, type FieldSize, type FieldState } from "@/components/ui/field"

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  help?: ReactNode
  state?: FieldState
  size?: FieldSize
  ref?: Ref<HTMLTextAreaElement>
}

export const Textarea = ({ label, help, state, size, disabled, className, id, ref, ...rest }: TextareaProps) => {
  const { fieldId, helpId, styles, controlProps } = useFieldA11y({ id, help, state, size, disabled })
  return (
    <div className={styles.root({ className })}>
      {label && (
        <label htmlFor={fieldId} className={styles.label()}>
          {label}
        </label>
      )}
      <div className={styles.control({ className: size === "sm" ? "py-200" : "py-350" })}>
        <textarea
          ref={ref}
          disabled={disabled}
          {...controlProps}
          className={styles.input({ className: `min-h-20 resize-y leading-relaxed ${disabled ? "text-fg-muted cursor-not-allowed resize-none" : ""}` })}
          {...rest}
        />
      </div>
      {help && (
        <div id={helpId} className={styles.help()}>
          {help}
        </div>
      )}
    </div>
  )
}
